const FETCH_EVENTS_BY_DEVICES_ID = 'FETCH_EVENTS_BY_DEVICES_ID';
export default FETCH_EVENTS_BY_DEVICES_ID;
